export default function videoRestorer(selector) {
  const videos = document.querySelectorAll(selector);

  if (!videos.length) return;

  function restoreVideos() {
    videos.forEach(video => {
      video.load();
      video.play().catch(() => {
        console.warn('Video autoplay blocked for:', video);
      });
    });
  }

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      restoreVideos();
    }
  });

  window.addEventListener('pageshow', () => {
    restoreVideos();
  });
}
